export const lessonsData = [
    {
        name: 'Basisles',
        duration: 50,
        level: 1,
        label1:'Logica',
        label2:'Tekenen',
        informationbold: 'In deze les leer je de basis van hoe je GoTo moet gebruiken',
        information:'In deze les gaan we een slinger tekenen. Dit ga je doen door de X- en Y-as te gebruiken. Succes!',
        endInformation: '- Een slinger te maken met de eerste letter van je naam.<br>- Een slinger maken van je hele naam.<br>- Een slinger maken van je favoriete dier.',
        checkpoints: [9,13, 18, 24, 27,32,35,38],
        steps: [
            {
                title: 'Gebruik je tablet',
                content: 'Heb je een tablet voor school? dan is het handig om deze te gebruiken voor deze website zoals je op het plaatje ziet.',
            },
            {
                title: 'X en Y as',
                content: 'Met de X- en Y-as kun je de arm van GoTo bewegen.',
            },
            {
                title: 'De X as',
                content: 'De X-as is verantwoordelijk voor de bewegingen naar links en naar rechts. Als het een negatief X-getal is word de afstand van de tekenarm naar het GoTo logo kleiner. Als het een positief X-getal is word de afstand van de tekenarm naar het GoTo logo groter. Negatieve getallen maken dus een beweging naar links en positieve getallen een beweging naar rechts.',
            },
            {
                title: 'De Y as',
                content: 'De Y-as is verantwoordelijk voor de bewegingen naar boven en naar beneden. Als het een negatief Y-getal is dan word de afstand van de tekenarm naar GoTo kleiner. Als het een positief Y-getal is word de afstand van de tekenarm naar Goto groter. Negatieve getallen maken dus een beweging naar beneden en positieve getallen een beweging naar boven.',
            },
            {
                title: 'Open Snap4Arduino',
                content: 'Open Snap4Arduino, sluit de GoTo aan zoals omschreven in de handleiding en importeer de GoTo blokjes in Snap4Arduino.',
            }
            ,
            {
                title: 'Check of je de GoTo blokjes hebt',
                content: 'Klik op de categorie Arduino zodat je de GoTo blokjes kunnen gebruiken. Zie je de GoTo blokjes niet? Dan moet je ze nog importeren. Kijk in de handleiding hoe je dit doet.',
            }
            ,
            {
                title: 'Blokjes gebruiken',
                content: 'Sleep "beweegX [ stappen ]& wacht tot klaar "naar het grijze werkveld (scripts).Met dit blokje kun je de arm over de X-as laten bewegen, naar links of naar rechts.',
            }
            ,
            {
                title: '+ en -',
                content: 'Door een negatief of een positief getal in te voeren bepaal je of GoTo zijn arm naar links of naar rechts beweegt. Voer in het witte vlak het getal 50 in, hierdoor zal GoTo zijn arm 50 stapjes naar rechts bewegen. (Bij een positief getal hoeven we geen + op te schrijven, bij een negatief getal wel een -)', 
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Klik op het blauwe gedeelte van het blokje om te zien wat je hebt gedaan. Als alles goed is gegaan zal GoTo nu een streep van links naar rechts tekenen.',
            }
            ,
            {
                title: 'De Y as',
                content: 'Om de arm naar boven of naar beneden te bewegen gebruiken we de Y-as',
            }
            ,
            {
                title: 'Blokjes gebruiken',
                content: 'Sleep nu het blokje "beweeg Y [ ] stappen" naar het grijze werkveld (scripts).',
            }
            ,
            {
                title: 'De Y as bewegen ',
                content: 'Wat je hebt gedaan bij het bewegen van de arm over de X-as kunnen we ook hier gebruiken.  Het verschil is dat de arm nu naar boven of beneden zal bewegen.  Een negatief getal zorgt ervoor dat de arm naar beneden beweegt en een positief getal zorgt ervoor dat de arm naar boven beweegt. Vul -50 in om de arm 50 stapjes naar beneden te laten bewegen.',
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Om te zien wat je gedaan hebt, klik je op het blauwe gedeelte van het blokje. Als alles goed is gegaan tekent GoTo een streep van boven naar beneden.',
            }
            ,
            {
                title: 'Vierkant tekenen',
                content: 'Nu je weet hoe de X- en Y-as werken gaan we een vierkant tekenen.',
            }
            ,
            {
                title: 'Maak je werkveld leeg',
                content: 'Haal alle blokjes uit het werkveld zodat je weer een leeg werkveld hebt.',
            }
            ,
            {
                title: 'Vierkant tekenen',
                content: 'Sleep "beweeg Y[ ] stappen & wacht tot klaar" naar het werkveld.  Met dit blokje kan je de arm over de Y -as laten bewegen en GoTo laten wachten tot hij hier mee klaar is. GoTo gaat daarna pas verder met de volgende blokjes. Vul het getal - 50 in om de eerste lijn van het vierkant te maken.',
            }
            ,
            {
                title: 'Vierkant tekenen',
                content: 'Om een vierkant te maken heb je meer dan 1 blokje nodig.  Door de blokjes tegen elkaar te slepen worden de blokjes aan elkaar gekoppeld. Om een vierkant te maken hebben we 4 blokjes nodig, elk blokje is 1 lijn van het vierkant. Voeg de laatste 3 blokjes toe om het vierkant af te maken (zie voorbeeld).',
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Klik op het blauwe gedeelte om het script te testen.',
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Je zult zien dat GoTo de blokjes na elkaar uitvoert.',
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Als het goed is gegaan heeft GoTo nu een vierkant getekend.',
            }
            ,
            {
                title: 'Slinger maken',
                content: 'Nu je weet hoe we een vierkant tekenen kunnen we een slinger van vierkanten maken.',
            }
            ,
            {
                title: 'Slinger maken',
                content: 'Elk vlaggetje van de slinger is een vierkant met daartussen een lijn. Het vierkant heb je al gemaakt, we hoeven alleen nog de extra lijn te tekenen. Dit doe je door een extra "beweegX [ ] stappen & wacht tot klaar" blokje toe te voegen.',
            }
            ,
            {
                title: 'Slinger maken',
                content: 'In dit blokje vul je het getal 100 in. We kiezen voor 100 zodat GoTo eerst weer over de bovenste lijn van het vierkant tekent (50) en daarna nog eens een lijn van 50 tekent waardoor tussenruimte ontstaat. Hierdoor zal GoTo na het vierkant ook een lijn van 100 stapjes (naar rechts) tekenen.',
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Klik nu op het blauwe gedeelte van 1 van de blokjes. Je zult zien dat GoTo 1 vlaggetje tekent.',
            }
            ,
            {
                title: 'Slinger maken',
                content: 'Als je deze tekening een aantal keer aan elkaar plakt krijg je een slinger. Hiervoor heb je het "herhaal [  ] " blokje, deze vind je onder de knop "besturen".',
            }
            ,
            {
                title: 'Slinger maken',
                content: 'Sleep het "herhaal [] keer " blokje in je werkveld. Koppel het herhaal blokje aan de blauwe blokjes zodat deze om de blauwe blokjes heen zit. Vul nu in het witte vlak van het "herhaal [] keer" blokje 4 in. Dit zorgt ervoor dat de blokjes 4 keer getekent worden ',
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Klik op de blokjes en zie wat er gebeurt. Als het goed is gegaan heb je nu een slinger getekend!',
            }
            ,
            {
                title: 'Driehoek slinger maken',
                content: 'We kunnen van de vierkante vlaggetjes driehoekige valggetjes maken. Dit kan door een eenvoudige stap, verander het tweede blokje "beweeg X [50] stappen & wacht tot klaar" in "beweeg X [50] stappen & Go door". Hierdoor worden beweegt X tegelijk met Y waardoor de lijn diagonaal zal gaa',
            }
            ,
            {
                title: 'Driehoek slinger',
                content: 'Klik op de blokjes en zie wat er gebeurt. Als het goed is gegaan heb je nu een slinger met driehoekige vlaggetjes getekend!',
            }
            ,
            {
                title: 'teken een golflijn',
                content: 'We beginnen met een enkele hoekige golf (zie voorbeeld).',
            }
            ,
            {
                title: 'Teken een golflijn',
                content: 'Net zoals in de vorige voorbeelden gebruik je de "Beweeg .. [ ] stappen & wacht tot klaar" blokken om de golf te tekenen.',
            },
            {
                title: 'Check of het werkt',
                content: 'Laat GoTo de golf tekenen om te controleren of deze goed is.',
            },
            {
                title: 'Herhaal je golf',
                content: 'Om een golflijn te krijgen moeten we de enkele golf herhalen.',
            },
            {
                title: 'Herhaal je golf',
                content: 'Je herhaalt de golf door er een "herhaal [ ] Keer" blok om heen te plaatsen. En vul in het getal 10 in om de beweging 10 keer te laten herhalen.',
            },
            {
                title: 'Check of het werkt',
                content: 'Laat GoTo de golflijn tekenen om te controleren of deze goed is.',
            }
            ,
            {
                title: 'Golflijn aanpassen',
                content: 'Nu ga je de golflijn puntig maken.',
            }
            ,
            {
                title: 'Golflijn aanpassen',
                content: 'Verander "beweegX [5] stappen & wacht tot klaar" naar de blokjes"beweegX [5] stappen en ga door ". Dit zorgt ervoor dat terwijl "beweegX [5] stappen" nog bezig is ook de volgende de stap wordt uitgevoerd. Op deze manier wordt de X as en de Y as tegelijk aangestuurd wat zorg voor een diagonale lijn.',
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Laat GoTo de golf tekenen om te controleren of deze goed is.',
            }
            ,
            {
                title: 'Maak de golflijn willekeurig',
                content: 'Als laatste ga je de golven willekeurige hoogtes geven.',
            }
            ,
            {
                title: 'Maak de golflijn willekeurig',
                content: 'Hiervoor heb je een variabele nodig. Deze voeg je toe door te klikken op variabelen.',
            }
            ,
            {
                title: 'Maak de golflijn willekeurig',
                content: 'Sleep het blokje scriptvariabelen naar je werkveld en plaats dit bovenaan. Verander daarna "a" in "willekeurig". Dit blokje zorgt ervoor dat je een willekeurig getal kunt maken.',
            }
            ,
            {
                title: 'Maak de golflijn willekeurig',
                content: 'Sleep het blokje "maak ▾ [willekeurig]" je werkveld in en plaast deze tussen "herhaal 10" en "beweegX [5] stappen. Omdat je deze na "herhaal 10" geplaatst hebt, wordt deze telkens opnieuw gemaakt.',
            }
            ,
            {
                title: 'Maak de golflijn willekeurig',
                content: ' Nu ga je het programma vertellen wat de variabele "willekeurig" inhoud. Dit doe je door een getal in het witte hokje te plaatsen. Om het getal ook daadwerkelijk willekeurig te maken moeten we een willekeurig getal genereren. Klik op "functies" en sleep het blokje "willekeurig getal tussen ( ) en ( )" in het witte hokje. Vul deze vervolgens in met -100 en 100, hierdoor wordt er een willekeurig getal gekozen tussen deze 2 getallen.',
            }
            ,
            {
                title: 'Maak de golflijn willekeurig',
                content: 'Nu je een willekeurig getal hebt gemaakt kun je deze gaan gebruiken. Het is de bedoeling dat de hoogte van de golven willekeurig wordt. Sleep nu "willekeurig" het werkveld in en plaats het in "beweegY [ ] stappen & wacht tot klaar" zoals in het voorbeeld.',
            }
            ,
            {
                title: 'Maak de golflijn willekeurig',
                content: 'Je hebt de hoogte van de golf nu willekeurig gemaakt. De lijn moet ook weer terug naar beneden worden getekend en dus heb je een negatief getal nodig. Dit kun je maken door een getal met -1  te vermenigvuldigen. Maar om ook de golf neerwaarts te tekenen ga je "willekeurig"met-2 vermenigvuldigen zodat dat de lijn twee keer zo lang getekend wordt.',
            }
            ,
            {
                title: 'Maak de golflijn willekeurig',
                content: 'Als laatst plaats je "" willekeurig""bij de laatste "beweegY [ ] stappen & wacht tot klaar" zoals in het voorbeeld. Test hem nu en kijk of je een willekeurige golflijn krijg. Voer hem daarna nog een keer uit en je zult zien dat deze tekening anders zal zijn.',
            }
            ,
            
        ]
    },
    {
        name: 'Drie op een rij',
        duration: 80,
        level: 4,
        label1:'Logica',
        label2:'Interface',
        checkpoints: [9,13,19],
        informationbold: 'In deze les ga je Drie op een rij met de GoTo maken met een digitale interface om een keuze voor een vakje te maken',
        information:"Je maakt eerst het speelveld van drie op een rij waar de goto steeds overheen loopt om de x en o's te tekenen",
        endInformation: '- Er 4 op een rij van maken.<br>- Je eigen symbolen maken in de plaats van rondje en kruisje.',
        steps: [
            {
                title: 'Maak een variabele aan',
                content: 'Als eerst maken we een nieuwe variabele aan genaamd stap Ga naar variabele> maak een variabele > noem deze stapWe maken deze variabele aan zodat we later makkelijk het spel groter of kleiner kunnen maken zonder alle code te hoeven aanpassen',
            },
            {
                title: 'Stel de variabele in',
                content: 'Voordat we kunnen beginnen moeten we aangeven hoeveel onze stap is pak het maak blok bij variabele en selecteer in de dropdown stap typ daarna in het tekstvak 100 Nu zeggen we eigenlijk maak variabele stap 100',
            },
            {
                title: 'Teken het speelveld',
                content: 'We gaan beginnen met het tekenen van het speelveld, waar  de GoTo steeds overheen loopt. Pak het blok beweeg x/y en doe er een x blok in uit het tablad functies en maak deze aan het blokje van de vorige stap Daarna stop je de variabele stap in het x blokje en vul je het aantal stappen dat je wilt zetten in het tweede tekstvakje als je deze voor x en y vast klaar zet kan je deze telkens kopieren',
            },
            {
                title: 'Teken het speelveld',
                content: 'Gebruik de blokken uit de vorige stap en maak dit na.',
            }
            ,
            {
                title: 'Teken het speelveld',
                content: 'Maak deze blokken en plak ze aan de blokken van de vorige stap.',
            }
            ,
            {
                title: 'Teken het speelveld',
                content: 'Maak deze blokken en plak ze aan de blokken van de vorige stap.',
            }
            ,
            {
                title: 'Teken het speelveld',
                content: 'Maak deze blokken en plak ze aan de blokken van de vorige stap.',
            }
            ,
            {
                title: 'Code opruimen',
                content: 'We gaan de code die we zojuist hebben gemaakt opruimen door deze in een blokje te zetten ga naar het tablad overig klik op maak een blok en noem deze speelveld druk dan op oke',
            }
            ,
            {
                title: 'Code opruimen en checken',
                content: 'sleep al je code van je canvas in de popup en druk op toepassen en dan oke check ook even of al je code hetzelfde is als in het voorbeeld zet het daarna het blokje speelveld in het canvas en maak er een blokje aan waneer vlaggetje word aangeklikt boven',
            }
            ,
            {
                title: 'Het rondje tekenen',
                content: 'Het speelveld is af nu gaan we de x en o maken van drie op een rij, eerst het rondje ',
            }
            ,
            {
                title: 'Het rondje tekenen',
                content: 'Maak deze blokken en plak ze aan de blokken van de vorige stap.',
            }
            ,
            {
                title: 'Code opruimen',
                content: 'We gaan de code die we zojuist hebben gemaakt opruimen door deze in een blokje te zetten ga naar het tablad overig klik op maak een blok en noem deze O druk dan op oke',
            }
            ,
            {
                title: 'Code opruimen en checken',
                content: 'sleep al je code van je canvas in de popup en druk op toepassen en dan oke check ook even of al je code hetzelfde is als in het voorbeeld',
            }
            ,
            {
                title: 'Het kruisje tekenen',
                content: 'Nu gaan we beginnen met het kruisje tekenen',
            }
            ,
            {
                title: 'Het kruisje tekenen',
                content: 'Maak deze blokken en plak ze aan de blokken van de vorige stap.',
            }
            ,
            {
                title: 'Het kruisje tekenen',
                content: 'Maak deze blokken en plak ze aan de blokken van de vorige stap.',
            }
            ,
            {
                title: 'Het kruisje tekenen',
                content: 'Maak deze blokken en plak ze aan de blokken van de vorige stap.',
            }
            ,
            {
                title: 'Code opruimen',
                content: 'We gaan de code die we zojuist hebben gemaakt opruimen door deze in een blokje te zetten ga naar het tablad overig klik op maak een blok en noem deze kruisje druk dan op oke',
            }
            ,
            {
                title: 'Code opruimen en checken',
                content: 'sleep al je code van je canvas in de popup en druk op toepassen en dan oke check ook even of al je code hetzelfde is als in het voorbeeld ',
            }
            ,
            {
                title: 'Keuze interface drie op een rij',
                content: 'Nu we alle elementen die getekent worden door de Goto hebben gemaakt kunne we beginnen aan onze interface op het scherm hiervoor gaan bovenin de balk van het tabblad scripts naar uiterlijken',
            }
            ,
            {
                title: 'Keuze interface drie op een rij',
                content: 'Klik op het kwastje wat langs de eerste sprite staat en maak een vierkant met de rectagle tool en houd shift ingedrukt zodat hij in proportie blijft vul hem daarna met het emmertje met een zwarte fill en druk op oke',
            }
            ,
            {
                title: 'Keuze interface drie op een rij',
                content: 'Klik met rechtermuisklik op het zwarte blokje > hernoem > en noem deze zwart',
            }
            ,
            {
                title: 'Keuze interface drie op een rij',
                content: 'Klik met rechtermuisklik op het zwarte blokje en kopieer hem en hernoem hem naar rood',
            }
            ,
            {
                title: 'Keuze interface drie op een rij',
                content: 'Klik met rechtermuisklik op het blokje genaamd rood klik op bewerken en maak het vierkant met het emmertje rood en druk op oke',
            }
            ,
            {
                title: 'Keuze interface drie op een rij',
                content: 'Rechts in het programmatje staat een soort van schermpje hieronder staat je blok wat je net aan hebt gemaakt dit is een sprite of element met 2 uiterlijken de rode en de zwarte. Deze gaan we dalijk gebruiken om te laten zien welke posities van drie op een rij al gevuld zijn. Maar om dit te doen moeten we de blokken 8 keer kopieren. Verander eerst de naam van het eerste blokje naar links_boven door er met rechter muisklik op te klikken',
            }
            ,
            {
                title: 'Keuze interface drie op een rij',
                content: 'Nu gaan we de andere 8 blokjes maken kopieer het blokje wat nu links_boven heet en noem deze midden_boven herhaal dit 7 keer en noem de blokken rechts_boven, links_midden, midden_midden, rechts_midden, links_beneden, midden_beneden, rechts_beneden. als het goed is heb je nu 9  blokken voor elke positie',
            }
            ,
            {
                title: 'Reset keuze interface linksboven',
                content: 'Het vlaggetje word onze reset knop nu gaan we vertellen wat elk blokje moet doen als ze gereset worden. We beginnen bij het blokje linksboven',
            }
            ,
            {
                title: 'Reset keuze interface middenboven',
                content: 'Dit moet natuurlijk ook voor alle andere blokken gebeuren je kan het blok in die sprite krijgen door hem erin te slepen dan hoef je alleen nog de getallen aan te passen naar deze coordinaten voor elk blok <br><br>Midden_boven:	x 0 	y 100 <br>Rechts_boven:		x 150 	y 100<br>Links_midden:		x -150 	y 0<br>Midden_midden:	x 0 	y 0<br>Rechts_midden:	x 150 	y 0<br>Links_beneden:		x -150 	y -100<br>Midden_beneden:	0 	y -100<br>Rechts_beneden:	x 150 	y -100',
            }
            ,
            {
                title: 'Variabele aanmaken',
                content: 'We kunnen nu de blokken die we gemaakt hebben resetten maar we moeten ook nog doorgeven aan de GoTo welk blok we ingekleurd willen hebben en welk symbool en de kleur van de blokken veranderen als de blokken zijn aangeklikt. Hiervoor hebben we een nieuwe variabele nodig genaamd kleur Ga naar variabele> maak een variabele > noem deze kleur',
            }
            ,
            {
                title: 'Verander de kleur met klik en zend signaal',
                content: 'We gaan een script maken die na elke klik de kleur variabele van 1 naar 0 en andersom zet zodat we hieruit later kunnen halen of de goto een x of een o moet tekenen begin met het blokje linksboven                ',
            }
            ,
            {
                title: 'Verander de kleur met klik en zend signaal',
                content: ' Dit script moet nu ook in alle andere blokjes komen sleep gewoon het hele script naar alle blokjes en verander de zend signaal naar de naam van het blokje',
            }
            ,
            {
                title: 'Route GoTo over het speelveld',
                content: 'Oke we zijn bijna zover we moeten de goto alleen nog vertellen wat hij moet tekenen na bepaalde signalen begin weer met linksboven  We geven de Goto het pad om naar elk blokje van linksonder te rijden en dan kies hij welke van de twee aan de beurt is doormiddel van variabele kleur en tekent hij een van de twee  daarna laten we de goto weer terug gaan naar het begin punt en kan de volgende zet gespeeld worden',
            }
            ,
            {
                title: 'Route GoTo over het speelveld',
                content: 'Dit gaan we nu dus weer 8 keer herhalen met een ander pad voor het juiste blokje (tip het is handig om de scripts in dezelfde volgorde te laten staan als de blokjes op het scherm)  <b>Laat dit script gewoon in linksboven staan dan houd je het overzicht van alle stappen in een sprite het is niet nodig voor dit script om in de juiste sprite te staan</b><br><br>midden boven',
            }
            ,
            {
                title: 'Route GoTo over het speelveld',
                content: 'Rechts boven',
            }
            ,
            {
                title: 'Route GoTo over het speelveld',
                content: 'links midden',
            }
            ,
            {
                title: 'Route GoTo over het speelveld',
                content: 'midden midden',
            }
            ,
            {
                title: 'Route GoTo over het speelveld',
                content: 'rechts midden',
            }
            ,
            {
                title: 'Route GoTo over het speelveld',
                content: 'links beneden',
            }
            ,
            {
                title: 'Route GoTo over het speelveld',
                content: 'midden beneden',
            }
            ,
            {
                title: 'Route GoTo over het speelveld',
                content: 'rechts beneden',
            }
            ,
            {
                title: 'Test of alles werkt',
                content: 'Als het goed is is dit nu je code in sprite linksboven en werkt het spel zoals het zou moeten Als je een blokje aanklikt op je interface op je scherm gaat de goto een x of een o tekenen in het corresponderende vakje in het echt en bij de volgende beurt tekent hij het andere symbool.',
            }
            
        ]
    },
    {
        name: 'Steen papier schaar',
        duration: 120,
        level: 3,
        label1:'Tekenen',
        label2:'Logica',
        informationbold: 'In deze les ga je Steen papier schaar met de GoTo maken.',
        information:"Je kunt zelf steen papier schaar tegen de GoTo spelen.",
        endInformation: '- de steen papier schaar mooier maken.<br>- Er in de plaats van steen papier schaar water spons vuur van maken.',
        checkpoints: [9,14,23],
        steps: [
            {
                title: 'Steen tekenen',
                content: 'We beginnen met het maken van de steen. de steen is gekartelt daarom maken we allemaal verschillende hoeken met deze stappen.',
            },
            {
                title: 'Steen tekenen',
                content: 'maak de nieuwe blokken vast aan de blokken van de vorige stap',
            },
            {
                title: 'Steen tekenen',
                content: 'maak de nieuwe blokken vast aan de blokken van de vorige stap',
            },
            {
                title: 'Steen tekenen',
                content: 'maak de nieuwe blokken vast aan de blokken van de vorige stap',
            }
            ,
            {
                title: 'Steen tekenen',
                content: 'maak de nieuwe blokken vast aan de blokken van de vorige stap',
            }
            ,
            {
                title: 'Steen tekenen',
                content: 'Nu maken we nog een extra lange lijn eraan zodat we meteen door kunnen met het volgende spel Anders zou het volgende element in het vorige element worden getekent.',
            }
            ,
            {
                title: 'Code opruimen',
                content: 'Nu de steen af is gaan we onze code opruimen Je gaat naar het tabje overig en klikt daar aan maak een blok noem deze Steen en laat deze staan op commando daarna druk je op oke',
            }
            ,
            {
                title: 'Code opruimen',
                content: 'Nu sleep je je hele rij code in het venster wat omhoog gekomen is en drukt op oke',
            }
            ,
            {
                title: 'Code opruimen en checken',
                content: 'Nu kun je bij overige een blokje steen uit het menu halen als je hierop klikt krijg je je tekening van de steen weer terug. Zet je pen maar even terug en test het uit! ',
            }
            ,
            {
                title: 'Papier tekenen',
                content: 'De steen is nu af nu gaan we het papier maken maar let op want we maken een schuine lijn bij het papier doormiddel van ga door.',
            }
            ,
            {
                title: 'Papier tekenen',
                content: 'Nu maken we nog een extra lange lijn eraan zodat we meteen door kunnen met het volgende spel',
            }
            ,
            {
                title: 'Code opruimen',
                content: 'Nu het papier af is gaan we weer onze code opruimen Je gaat naar het tabje overig en klikt daar aan maak een blok noem deze Papier en laat deze staan op commando daarna druk je op oke',
            }
            ,
            {
                title: 'Code opruimen',
                content: 'Nu sleep je je hele rij code in het venster wat omhoog gekomen is en drukt op oke',
            }
            ,
            {
                title: 'Code opruimen en checken',
                content: 'Nu kun je bij overige een blokje papier uit het menu halen als je hierop klikt krijg je je tekening van het papier weer terug. Weer testen',
            }
            ,
            {
                title: 'Schaar tekenen',
                content: 'De steen en het papier is af dus we kunnen door met het maken van de schaar Eerst gaan we de handvaten maken',
            }
            ,
            {
                title: 'Schaar tekenen',
                content: 'maak de nieuwe blokken vast aan de blokken van de vorige stap',
            }
            ,
            {
                title: 'Schaar tekenen',
                content: 'maak de nieuwe blokken vast aan de blokken van de vorige stap',
            }
            ,
            {
                title: 'Schaar tekenen',
                content: 'De handvaten zijn klaar nu gaan we het knip gedeelte maken doormiddel van wacht tot klaar en ga door',
            }
            ,
            {
                title: 'Schaar tekenen',
                content: 'maak de nieuwe blokken vast aan de blokken van de vorige stap',
            }
            ,
            {
                title: 'Schaar tekenen',
                content: 'Nu maken we nog een extra lange lijn eraan zodat we meteen door kunnen met het volgende spel',
            }
            ,
            {
                title: 'Code opruimen',
                content: 'Nu de schaar af is gaan we weer onze code opruimen Je gaat naar het tabje overig en klikt daar aan maak een blok noem deze Schaar en laat deze staan op commando daarna druk je op oke',
            }
            ,
            {
                title: 'Code opruimen',
                content: 'Nu sleep je je hele rij code in het venster wat omhoog gekomen is en drukt op oke',
            }
            ,
            {
                title: 'Code opruimen en checken',
                content: 'Nu kun je bij overige een blokje schaar uit het menu halen als je hierop klikt krijg je je tekening van de schaar weer terug',
            }
            ,
            {
                title: 'Variabele aanmaken',
                content: 'We hebben onze 3 elementen getekend nu kunnen we beginnen aan ons programma We willen dat het programma een willekeurige tekening uitkiest Het eerste wat we gaan doen is een variabele aanmaken die willekeurig heet Ga naar het kopje variabelen  Klik op maak een variabele Noem deze willekeurig en druk op oke',
            }
            ,
            {
                title: 'Variabele instellen',
                content: 'In het tabje variabele pakken we het blokje maak [] [0] in ons canvas slepen En dan klik je bij het uitklap menu willekeurig aan',
            }
            ,
            {
                title: 'Programma maken',
                content: 'Nu moeten we het stukje waar 0 staat in ons maak blok nog invullen hiervoor gaan we naar het tabje functies En sleep je het blokje willekeurig getal tussen 1 en .. in het canvas Van het laatste getal maak je een 3 dus dan word het een willekeurig getal tussen de 1 en 3 En dan sleep je het groene blokje in het oranje blokje op de plek waar de 0 staat Nu maakt dit blokje als je hem activeert variabele random een willekeurig getal tussen de 1 en de 3',
            }
            ,
            {
                title: 'Programma maken',
                content: 'Het blokje maak random een willekeurig getal tussen 1 en 3 doet nu verder nog niets met onze steen papier schaar dit gaan we nu toevoegen Als eerst gaan we naar het tabje besturen en slepen maken we aan ons maak blokje 3 als blokjes',
            }
            ,
            {
                title: 'Programma maken',
                content: 'We gaan weer terug naar functies en slepen het blokje Is .. gelijk aan .. ? In het bovenste deel van het als blokje bij alle drie de als blokken',
            }
            ,
            {
                title: 'Programma maken',
                content: 'Het is gelijk aan blokje is nu nog leeg deze gaan we vullen met onze variabele random Dus we gaan weer naar het tabje variabele en slepen random in het blokje is gelijk aan in het blokje als aan de linker kant van het is gelijk aan blokje Bij alle drie de als blokken',
            }
            ,
            {
                title: 'Programma maken',
                content: 'We zijn er bijna het enige wat we nog moeten doen is zeggen waar het gelijk aan moet zijn en wat het programma dan moet uitvoeren We beginnen gewoon bovenaan  en vullen aan de rechter kant van het is gelijk aan blokje een 1 in Bij het tweede als blokje vullen we een 2 in En bij het derde blokje vullen we een 3 in',
            }
            ,
            {
                title: 'Programma invullen',
                content: 'Het script doet nu wat hij moet doen hij heeft alleen nog geen inhoud nu pakken we onze steen papier schaar blokjes er weer bij en slepen deze in de 3 als blokken Het maakt niet uit welke je in welk als blokje doet maar het logischte is om Steen bij gelijk aan 1 te doen Papier bij gelijk aan 2 En schaar bij gelijk aan 3',
            }
            ,
            {
                title: 'Programma testen',
                content: 'Het programmatje is klaar als je er nu op klikt gaat hij een van de drie opties uittekenen op het vel papier Veel plezier!',
            }
        ]
    }
    ,
    {
        name: 'Galgje',
        duration: 45,
        level: 2,
        label1:'Tekenen',
        label2:'Logica',
        informationbold: 'In deze les ga je Galgje voor de GoTo maken.',
        information:"Je maakt alle stappen en daarna zeg je bij elke keer dat de spatiebalk ingedrukt word teken een deel van de lijn.",
        endInformation: '- De goto als een wekker af laten gaan door zijn arm te bewegen als de spelers verloren hebben',
        checkpoints: [12],
        steps: [
            {
                title: 'Galgje tekenen',
                content: 'Om galgje te tekenen gaan we eerst alle stappen uittekenen en dan in een blokje zetten We beginnen met de voet lijn',
            }
            ,
            {
                title: 'Galgje tekenen',
                content: 'Dit blokje zetten we nu in een nieuw blokje genaamd lijn1 ga naar <b>overig></b> maak een blok noem deze <b>lijn 1</b> en klik op oke <b>sleep</b> nu de beweeg x 200 | wacht tot klaar van het canvas in de popup en druk op toepassen en oke',
            }
            ,
            {
                title: 'Galgje tekenen',
                content: 'Nu gaan we de tweede lijn maken We gaan eerst terug door middel van Beweeg x -100 | wacht tot klaar En dan maken we de stijl Beweeg y -250 | wacht tot klaar En zet deze in een nieuw blokje genaamd lijn 2 ',
            }
            ,
            {
                title: 'Galgje tekenen',
                content: 'Lijn 3 Beweeg x -150 | wacht tot klaar En zet deze in een nieuw blokje genaamd lijn 3 ',
            }
            ,
            {
                title: 'Galgje tekenen',
                content: 'Lijn 4  Beweeg y 50 | wacht tot klaar En zet deze in een nieuw blokje genaamd lijn 4 ',
            }
            ,
            {
                title: 'Galgje tekenen',
                content: 'Nu we de galg hebben gaan we het hoofd tekenen maak deze blokken na en zet deze in een nieuw blokje genaamd hoofd ',
            }
            ,
            {
                title: 'Galgje tekenen',
                content: 'Na het hoofd maken we het lijf van het poppetje maak deze blokken na en zet deze in een nieuw blokje genaamd lijf',
            }
            ,
            {
                title: 'Galgje tekenen',
                content: 'Linker arm, maak deze blokken na en zet deze in een nieuw blokje genaamd linker arm <b>let op de Ga door</b>',
            }
            ,
            {
                title: 'Galgje tekenen',
                content: 'Rechter arm, maak deze blokken na en zet deze in een nieuw blokje genaamd rechter arm <b>let op de Ga door</b>',
            }
            ,
            {
                title: 'Galgje tekenen',
                content: 'Linker been, maak deze blokken na en zet deze in een nieuw blokje genaamd linker been <b>let op de Ga door</b>',
            }
            ,
            {
                title: 'Galgje tekenen',
                content: 'Rechter been, maak deze blokken na en zet deze in een nieuw blokje genaamd rechter been <b>let op de Ga door</b>',
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Als het goed is als je nu alle blokjes onder elkaar plakt tekent hij de tekening die hier boven in de balk staaat',
            }
            ,
            {
                title: 'Programma maken',
                content: 'Sleep het wanneer spatiebalk word ingedrukt in het canvas uit besturen>wanneer spatiebalk word ingedrukt',
            }
            ,
            {
                title: 'Programma maken',
                content: 'Maak nu aan de waneer spatiebalk word ingedruk  Plak er 10 als blokken onder Ga daarna naar overig> en zet tussen elk als blok de lijnen en onderdelen op volgorde ertussen ',
            }
            ,
            {
                title: 'Programma maken',
                content: 'Ga naar variabelen>maak een variabele en noem deze variabele spatiestap ',
            }
            ,
            {
                title: 'Programma maken',
                content: 'Ga naar variabelen> en pak het blok verander .. met … En zet hierin verander spatiestap met 1 En zet deze tussen het waneer spatiebalk word ingedrukt blok en het eerste als blok ',
            }
            ,
            {
                title: 'Programma maken',
                content: 'In het laatse als blokje moeten we onze stappen weer resetten  Ga naar variabelen> en pak het blok maak … …. Zet deze onderaan in het laatste als blok en vul in maak spatiestap 0 ',
            }
            ,
            {
                title: 'Programma maken',
                content: 'Ga naar het tabje functies En sleep is gelijk aan in het canvas ',
            }
            ,
            {
                title: 'Programma maken',
                content: 'Ga naar het tabje variabele pak de variabele spatiestap en plaats deze aan de  linker kant in het is gelijk aan blok',
            },
            {
                title: 'Programma maken',
                content: 'Kopieer dit blokje en zet hem in alle als blokken',
            }
            ,
            {
                title: 'Programma maken',
                content: 'Vul het rechter deel van de is gelijk aan blokken in bovenaan 1 tot onderaan 10',
            }
            ,
            {
                title: 'Programma resetten',
                content: 'Als je het groene vlaggetje als reset knop wilt gebruiken moet je dit scriptje nog even langs je andere script zetten',
            }
            ,
            {
                title: 'Programma testen',
                content: 'Als je nu op spatie drukt tekent de GoTo steeds de volgende stap van galgje Veel plezier!',
            }
            ,
            
        ]
    }
    ,
    {
        name: 'Wekker',
        level: 1,
        label1:'Muziek',
        label2:'Tijd',
        informationbold: 'Je kan de GoTo tekenrobot ook voor andere dingen gebruiken als alleen tekenen hij maakt namenlijk ook veel geluid.',
        information:"In deze les ga je leren hoe je je eigen wekker kan maken van je GoTo en deze bijvoorbeeld om de 5 minuten af laten gaan.",
        endInformation: '- maak de wekker achter andere lessen als je afgaat bijvoorbeeld <br>- je kan een sambabal knutselen met een wc rolletje en rijst, en deze in de arm van de GoTo doen als extra effect. <br>- Je kan de tijd tussen de wekker of het geluid van de wekker in de code veranderen. <br>- laat de GoTo met een theelepetje tegen een kopje aan tikken voor een extra geluid.',
        checkpoints: [5],
        steps: [
            {
                title: 'Start knop',
                content: 'In deze les gaan we in de plaats van iets tekenen de goto zijn geluid gebruiken om een wekker te maken als eerst gaan we de start knop maken sleep als vlaggetje word ingedrukt in het canvas',
            }
            ,
            {
                title: 'Wekker maken',
                content: 'Pak een herhaal blokje uit het tabje besturen en sleep deze in je canvas en plak deze aan het vorige blokje',
            }
            ,
            {
                title: 'Wekker maken',
                content: 'Pak daarna het herhaal … keer blokje en zet deze in het vorige blokje vul het lege plekje met 20 keer',
            }
            ,
            {
                title: 'Tijd tussen de wekkers',
                content: 'Pak het wacht blokje en zet deze tussen het buitenste en binnenste herhaal blokje en vul 30 seconden in dit word de tijd dat de goto wacht tussen het afgaan van de wekker',
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Zet de blokken van het plaatje in het binnenste herhaal blokje als je dit gedaan hebt druk maar even op het groene vlaggetje en kijk of het werkt',
            }
            ,
            {
                title: 'Pas je wekker',
                content: 'Als je wil kan je het geluid wat de goto maakt als hij afgaat veranderen door er andere blokjes in te zetten of het aantal keer herhalen aan te passen en de tijd tussen het afgaan kan je veranderen door de wacht 30 seconden groter of kleiner te maken',
            }
            ,
            
        ]
    }
    ,
    {
        name: 'Cactus level',
        level: 2,
        label1:'Interactief',
        label2:'Tekenen',
        informationbold: 'In deze les gaan we het spelletje wat je kan spelen als je geen internet hebt namaken.',
        information:"Door op het vlaggetje te drukken start je het spel en door op spatie te drukken spring je.",
        endInformation: '- het spel langer maken door de getallen te veranderen.<br>- andere obstakels toevoegen en er je eigen parkour van maken.<br>- proberen een limiet op het springen te zetten.',
        checkpoints: [5, 11, 13],
        steps: [
            {
                title: 'Cactus maken',
                content: 'Als eerst gaan we het parkour uittekenen hiervoor hebben we cactussen nodig maak een nieuw blokje genaamd cactus door naar het tabje overig te gaan en klik dan op maak een blok en noem deze cactus',
            }
            ,
            {
                title: 'Cactus maken',
                content: 'Maak in de popup deze blokken na',
            }
            ,
            {
                title: 'Cactus maken',
                content: 'Voeg de nieuwe blokken toe',
            }
            ,
            {
                title: 'Cactus maken',
                content: 'Voeg de nieuwe blokken toe en druk op oke',
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Ga nu in je menu terug naar overig hier zie je een nieuw blokje genaamd cactus sleep deze in je canvas en klik er op als het goed is tekent de goto nu de cactus uit',
            }
            ,
            {
                title: 'Parkour maken',
                content: 'Nu we de cactus hebben gaan we het parkour maken als eerst gaan we aangeven waneer het parkour getekent moet worden ga naar het tabje besturen en pak het waneer .. word ingedrukt en sleep deze in je canvas',
            }
            ,
            {
                title: 'Parkour maken',
                content: 'Naast waneer staat een dropdown menu als je hierop klikt kan je een keuze maken kies hier 1 zodat er staat waneer 1 word ingedrukt',
            }
            ,
            {
                title: 'Parkour maken',
                content: 'Oke nu kunnen we het parkour echt gaan maken maak de blokken uit de foto na',
            }
            ,
            {
                title: 'Parkour maken',
                content: 'Voeg de nieuwe blokken toe',
            }
            ,
            {
                title: 'Parkour maken',
                content: 'Voeg de nieuwe blokken toe',
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Als je op 1 op je toetsenbord drukt tekent de GoTo het parkour voor het spel uit',
            }
            ,
            {
                title: 'Lijn tekenen',
                content: 'Nu moet de GoTo nog een lijn gaan tekenen pak het wanneer vlaggetje word aangeklikt blok uit besturen en sleep deze in je canvas',
            }
            ,
            {
                title: 'Lijn tekenen',
                content: 'Maak de blokken uit de afbeelding na',
            }
            ,
            {
                title: 'Check of het werkt',
                content: 'Als het goed is als je nu op vlaggetje klikt tekent de goto een lange lijn heen en weer',
            }
            ,
            {
                title: 'Spring functie',
                content: 'Oke het spel werkt zover alleen we kunnen nog niet over de cactussen heen springen pak het wanneer .. word ingedrukt blok uit het tabje besturen en vul hem met de spatiebalk',
            }
            ,
            {
                title: 'Spring functie',
                content: 'Maak de blokken in de afbeelding na',
            }
            ,
            {
                title: 'Testen',
                content: 'Als het goed is ziet je bestand er ongeveer zo uit test of het werkt druk eerst op 1 om het level uit te tekenen als de GoTo hier mee klaar is druk dan op het vlaggetje en spring met spatiebalk over de cactussen heen',
            }
            ,
            
        ]
    }
    ,
];


// WEBPACK FOOTER //
// ./resources/assets/utilities/lessons.js